import React, { useContext, useState, useRef } from "react";
import timesheet from "./Timesheet.module.css";
import { AgGridReact } from "@ag-grid-community/react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import DatePicker from "react-multi-date-picker";
import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ClientSideRowModelModule } from "@ag-grid-community/client-side-row-model";
import { ModuleRegistry } from "@ag-grid-community/core";
import { RowGroupingModule } from "@ag-grid-enterprise/row-grouping";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import TimesheetSummary from "../../../components/Timesheet/TimesheetSummary.js";
import TimesheetChart from "../../../components/Timesheet/TimesheetChart.js";
import CommanDialog from "../../../components/CommonCompo/CommanDialog/CommanDialog.js";
import { useTimesheet } from "../../../Hooks/Features/Timesheet/useTimesheet.js";
import { useCommon } from "../../../Hooks/Common/useCommon.js";
import { ToastContext } from "../../../context/ToastContext.js";
import { SkeletonDataTable } from "../../../components/Loader/Loader.jsx";
import PendingTimesheet from "../../../components/Timesheet/PendingTimesheet.jsx";
import { useEmployeFilter } from "../../../context/EmployeFilterContext.js";
import CommonFilterDropdown from "../../../components/CommonCompo/CommonFilterDropdown/CommonFilterDropdown.jsx";
import { convertTo12HourFormat, dateConvert } from "../../../utils/Helper.js";
ModuleRegistry.registerModules([ClientSideRowModelModule, RowGroupingModule]);

const Timesheet = () => {

  const { checkPermission, getValuePermission } = useCommon();
  const { showInfo } = useContext(ToastContext);
  const { columnDefs, upsertPendingTimesheet, visible, setVisible, handleMonthChange, getExcelDownload, onCellClicked, handleDateChange, timeSheetOpen, setTimeSheetOpen, columns, tagRef, timesheetOptions, loader, rowDatas, pinnedBottomRowData, excelLoader, getManagerExcelDownload, setManagerTimesheetData, handleDownloadTimeSheet, getAllEmployeeTimesheetExcel, filterValues, setFilterValues, detailsPopup, setDetailsPopup } = useTimesheet();
  const { badget } = useEmployeFilter();
  const [showFiltersDrawer, setShowFiltersDrawer] = useState(false);
  const datePickerRef = useRef(null);

  const gridOptions = {
    columnDefs: columnDefs,
    autoGroupColumnDef: {
      pinned: "left",
      hide: true,
      width: 200,
    },
    defaultColDef: {
      width: 120,
      autoHeaderHeight: true,
    },
  };

  return (
    <div className={`row mx-0 ${timesheet["tabeview"]}`} ref={() => checkPermission("timesheet", tagRef)}>
      <div ref={tagRef} id='{"tabname": "timesheet", "data": "manager_timesheet_details_tab"}' >
        <div className="row mx-0 mt-2">
          <div className="col-md-3 col-xs-12 text-primary d-flex align-items-center gap-1">
            <span className={`icon-btn-nospace py-2 px-2 c-pointer border ${timesheet["nav-prev-btn"]}`} onClick={() => handleMonthChange("prev")}>
              <FontAwesomeIcon icon="fa-solid fa-arrow-left" />
            </span>
            <span className={`py-2 px-3 c-pointer border text-center ${timesheet["nav-curr-btn"]}`} onClick={() => handleMonthChange("curr")}>Current</span>
            <span className={`icon-btn-nospace py-2 px-2 c-pointer border ${timesheet["nav-next-btn"]}`} onClick={() => handleMonthChange("next")}>
              <FontAwesomeIcon icon="fa-solid fa-arrow-right" />
            </span>
          </div>
          <div className="col-md-9 col-sm-12 padd0 d-flex gap-2 justify-content-end align-items-center flex-wrap">
            {(timesheetOptions === "details" && !getValuePermission("manager_timesheet_excel_download_btn")) &&
              <button title="Employee Timesheet" className="sk-btn sk-btn-primary" onClick={getAllEmployeeTimesheetExcel} ><FontAwesomeIcon icon="fa-solid fa-file-arrow-down" /></button>
            }
            <button onClick={() => { handleDateChange(); setFilterValues((prev) => ({ ...prev, apiCall: true })) }} className="sk-btn sk-btn-primary" title="Refresh Timesheet"><FontAwesomeIcon icon="fa-solid fa-arrows-rotate" /></button>
            <button className="sk-btn sk-btn-primary" onClick={() => setShowFiltersDrawer(true)} title="Filters">
              <FontAwesomeIcon icon="fa-solid fa-filter" />
            </button>
            {!getValuePermission("approve_timesheet_tab") &&
              <button className="sk-btn sk-btn-primary position-relative " title="Pending Timesheet" onClick={() => setTimeSheetOpen(true)}>
                <FontAwesomeIcon icon="fa-solid fa-clock" />
                {badget?.manager_timesheet_details_tab?.[0]?.counts > 0 && <div className='notification-count d-flex justify-content-center align-items-center' style={{ right: 0 }} >{badget?.manager_timesheet_details_tab?.[0]?.counts}</div>}
              </button>
            }
            {!getValuePermission("approve_timesheet_tab") &&
              <button className="sk-btn sk-btn-primary" onClick={() => { if (filterValues?.date?.[0] !== undefined || filterValues?.date?.[1] !== undefined) { setVisible(true) } else { showInfo("Info", "Please Select Date."); } }} title="Submit Timesheet"><FontAwesomeIcon icon="fa-solid fa-paper-plane" /></button>
            }

            {timesheetOptions === 'summary' &&
              <>
                {!getValuePermission("manager_timesheet_excel_download_btn") && <button title="Manager Timesheet" className="sk-btn sk-btn-primary" onClick={getManagerExcelDownload} ><FontAwesomeIcon icon="fa-solid fa-file-arrow-down" /></button>}
                {!getValuePermission("hr_timesheet_excel_download_btn") && (!excelLoader ?
                  <button title="HR Timesheet" className="sk-btn sk-btn-primary" onClick={getExcelDownload}><FontAwesomeIcon icon="fa-solid fa-file-arrow-down" /></button> :
                  <button className="sk-btn sk-btn-primary">
                    <div className={`spinner-border ${timesheet["spinner-icon"]}`} role="status"><span className="sr-only"></span></div>
                  </button>)
                }
              </>
            }

          </div>
        </div>

        {timesheetOptions === "details" && (loader ? <SkeletonDataTable numSkeletons={20} /> :
          <div className={`ag-theme-alpine custom-grid ${timesheet["grid-container"]}`}>
            <AgGridReact rowHeight={30} headerHeight={30} columnDefs={columnDefs} gridOptions={gridOptions} rowData={rowDatas} onCellClicked={onCellClicked} groupDefaultExpanded="-1" pinnedBottomRowData={pinnedBottomRowData} />
          </div>
        )}
        {timesheetOptions === "summary" && <TimesheetSummary filterValues={filterValues} setFilterValues={setFilterValues} tab={timesheetOptions} getData={(data) => setManagerTimesheetData(data)} />}
        {timesheetOptions === "chart" && <TimesheetChart filterValues={filterValues} setFilterValues={setFilterValues} tab={timesheetOptions} />}
        <Dialog className={`timesheet-dialog ${timesheet["timesheet-dialog"]}`} modal={true} draggable={false} visible={detailsPopup?.visible} onHide={() => setDetailsPopup((prev) => ({ ...prev, visible: false }))}
          header={() => {
            return (
              <div>{detailsPopup?.userName}{" "} {detailsPopup?.workLogDate && <span className={timesheet["dialog-header-date"]}>[ {detailsPopup?.workLogDate} ]</span>}
                <span className={timesheet["dialog-header-hours-warning"]} >{detailsPopup?.workHours && <> [ Hours: {detailsPopup?.workHours} ]</>}</span>
              </div>
            );
          }}>
          {detailsPopup?.punchData && detailsPopup.punchData.length > 0 && (
            <div className="mb-3 p-3 border rounded bg-light">
              <h6 className="text-black fw-bold mb-2">
                <FontAwesomeIcon icon="fa-solid fa-clock" className="me-2 text-primary" />
                Punch Report
              </h6>
              <div className="table-responsive">
                <table className={`table table-bordered table-sm align-middle text-center mb-0 ${timesheet["punch-report-table"]}`}>
                  <thead className="table-dark">
                    <tr>
                      <th>Date</th>
                      <th>Shift In / Out</th>
                      <th>Punch In / Out</th>
                      <th>Tap In / Out</th>
                      <th>Lunch In / Out</th>
                      <th>Working Hours</th>
                      <th>Extra Hours</th>
                      <th>Deficit Hours</th>
                    </tr>
                  </thead>
                  <tbody>
                    {detailsPopup.punchData.map((item, idx) => (
                      <tr key={idx}>
                        <td>{item.shift_date ? dateConvert(item.shift_date, "day-month-year") : '-'}</td>
                        <td>
                          {item.shift_startdate || item.shift_enddate ? (
                            <span className="badge bg-secondary">
                              {item.shift_startdate ? convertTo12HourFormat(item.shift_startdate) : '-'} to {item.shift_enddate ? convertTo12HourFormat(item.shift_enddate) : '-'}
                            </span>
                          ) : '-'}
                        </td>
                        <td>
                          <span className="text-success fw-bold">{item.actual_starttime ? convertTo12HourFormat(item.actual_starttime) : '-'}</span>
                          <span className="mx-1">/</span>
                          <span className="text-danger fw-bold">{item.actual_endtime ? convertTo12HourFormat(item.actual_endtime) : '-'}</span>
                        </td>
                        <td>
                          <span className="text-success">{item.insights_starttime ? convertTo12HourFormat(item.insights_starttime) : '-'}</span>
                          <span className="mx-1">/</span>
                          <span className="text-danger">{item.insights_endtime ? convertTo12HourFormat(item.insights_endtime) : '-'}</span>
                        </td>
                        <td>
                          {item.insights_lunch_starttime ? convertTo12HourFormat(item.insights_lunch_starttime) : '-'}
                          <span className="mx-1">/</span>
                          {item.insights_lunch_endtime ? convertTo12HourFormat(item.insights_lunch_endtime) : '-'}
                        </td>
                        <td className="fw-bold">{item.working_hours || '-'}</td>
                        <td className="text-success">{item.extra_hours_decimal || '-'}</td>
                        <td className="text-danger">{item.deficit_hours || '-'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
          <div className="timesheet-data-table">
            <div className="d-flex justify-content-end mb-2">
              <button title="Timesheet" onClick={handleDownloadTimeSheet}><FontAwesomeIcon icon="fa-solid fa-file-arrow-down" /></button>
            </div>
            <DataTable tableStyle={{ minWidth: "50%" }} value={detailsPopup?.tableData} rowGroupMode="rowspan" groupRowsBy="day_date"  sortOrder={1} scrollable scrollHeight="80vh">
              {columns?.map((col, i) => (
                <Column key={col.field} field={col.field} header={col.header} style={{ width: col?.width ? col.width + "%" : "auto", minWidth: col?.width ? col.width + "%" : "auto" }} body={col.field === "key" ? (rowData) => <a href={rowData.issueUrl} target="_blank" rel="noreferrer">{rowData.key}</a> : ""} />
              ))}
            </DataTable>
          </div>
        </Dialog>
      </div>
      {timeSheetOpen && <PendingTimesheet setTimeSheetOpen={setTimeSheetOpen} timeSheetOpen={timeSheetOpen} hover={filterValues?.date} />}
      <CommanDialog visible={visible} message={"Are you sure you want to continue?"} handleClose={() => setVisible(false)} handleFun={() => upsertPendingTimesheet()} />

      {/* Right Panel Filters Drawer */}
      <div className={`sk-drawer-overlay ${showFiltersDrawer ? 'active' : ''}`} onClick={(e) => { if (e.target === e.currentTarget) setShowFiltersDrawer(false); }}>
        <div className={`sk-drawer-panel ${showFiltersDrawer ? 'open' : ''}`}>
          <div className="sk-drawer-header">
            <h5 className="sk-drawer-title">Filters</h5>
            <div className="d-flex align-items-center gap-2">
              <button className="sk-drawer-clear-btn" onClick={() => {
                setFilterValues((prev) => ({
                  ...prev,
                  projects: [],
                  users: [],
                  issue_type: [],
                  project_leads: [],
                  apiCall: true
                }));
              }}>Clear All</button>
              <button className="sk-drawer-close-btn" onClick={() => setShowFiltersDrawer(false)}>
                <FontAwesomeIcon icon="fa-solid fa-xmark" />
              </button>
            </div>
          </div>
          <div className="sk-drawer-body">
            <div className='d-flex flex-column gap-4'>
              {/* Date Picker Filter */}
              <div className="sk-drawer-filter-group">
                <div className="task-list-filter-label">Date Range</div>
                <DatePicker ref={datePickerRef}
                  value={filterValues?.date}
                  onChange={(date) => {
                                            if (!date || date.length === 2) {
                                                setFilterValues((prev) => ({ ...prev, date: date, isChange: true }));
                    handleDateChange();
                    if (date && date.length === 2) {
                      setFilterValues((prev) => ({ ...prev, apiCall: true }));
                      datePickerRef.current?.closeCalendar();
                    }
                                            }
                                        }}
                  range
                  rangeHover
                  numberOfMonths={2}
                  containerClassName="w-100"
                  inputClass="w-100 sk-input-dd"
                  placeholder="Select Dates"
                />
              </div>

              {/* Dimensions Dropdown Filters */}
              <div className="sk-drawer-filter-group">
                <div className="task-list-filter-label">Dimensions</div>
                <CommonFilterDropdown
                  fields={[
                    { key: "projects", label: "Projects", col: 12 },
                    { key: "users", label: "Users", col: 12 },
                    { key: "issue_type", label: "Types", col: 12 },
                    { key: "project_leads", label: "Lead", col: 12 }
                  ]}
                  filterValues={filterValues}
                  setFilterValues={setFilterValues}
                />
              </div>
            </div>
          </div>
          <div className="sk-drawer-footer">
            <button className="sk-btn .sk-btn-primary-filter w-100 py-2" onClick={() => {
              setFilterValues((prev) => ({ ...prev, apiCall: true }));
              setShowFiltersDrawer(false);
            }}>Apply Filters</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Timesheet;